import { render, staticRenderFns } from "./SubMenuPage.vue?vue&type=template&id=373733fc"
import script from "./SubMenuPage.vue?vue&type=script&lang=js"
export * from "./SubMenuPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports